module.exports = __webpack_public_path__ + "static/media/main-bg@2x.66ca22c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/main-bg@2x.png
// module id = 992
// module chunks = 0